import { Box, Button, IconButton, Pagination, TableCell, TableFooter } from '@mui/material';
import styled from 'styled-components';

export const StyledFooter = styled(TableFooter)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.palette.grey[200]};
`;

export const StyledNavButton = styled(Button)`
  :disabled {
    opacity: 0.6;
  }
`;

export const StyledPagination = styled(Pagination)`
  button {
    color: ${({ theme }) => theme.palette.grey[500]};

    &.Mui-selected {
      background-color: ${({ theme }) => theme.palette.primary[50]};
      color: ${({ theme }) => theme.palette.primary[600]};
    }

    :hover {
      background-color: ${({ theme }) => theme.palette.primary[50]};
      color: ${({ theme }) => theme.palette.primary[600]};
    }
  }
`;

export const HeaderWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderCell = styled(TableCell)`
  padding: 12px 24px;
  background-color: ${({ theme }) => theme.palette.grey[50]};
`;

export const MainCell = styled(TableCell)`
  padding: 16px 24px;
  border: 0;
`;

export const IconButtonWrapper = styled(IconButton)`
  box-shadow: none;
  transition: all 0.2s ease-out;
  color: ${({ theme }) => theme.palette.primary.main};

  :hover {
    background-color: ${({ theme }) => theme.palette.primary[50]};
  }
`;

export const ContainedIconButtonWrapper = styled(IconButtonWrapper)`
  color: ${({ theme }) => theme.palette.grey[25]};
  background-color: ${({ theme }) => theme.palette.primary.main};

  :hover {
    background-color: ${({ theme }) => theme.palette.primary[700]};
  }
`;

export const CloseModalButton = styled(IconButton)`
  box-shadow: none;
  transition: all 0.2s ease-out;
  color: ${({ theme }) => theme.palette.grey.main};

  :hover {
    background-color: ${({ theme }) => theme.palette.grey[50]};
  }
`;

export const LoadingWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.base.background};
  border-radius: 8px;
`;

export const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  background-color: ${({ theme }) => theme.palette.base.background};
  box-shadow: ${({ theme }) => theme.shadows[26]};
  border-radius: 8px;
`;
